
import { useState } from 'react';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'David Mitchell',
      role: 'Homeowner',
      content: 'Excellent service from start to finish. They upgraded our switchboard and installed new power points throughout the house. Professional, punctual, and very thorough with their work.',
      rating: 5,
    },
    {
      name: 'Sarah Thompson',
      role: 'Property Manager',
      content: 'We engaged NS Electrical for a commercial fit-out project. Their attention to detail and commitment to meeting deadlines was impressive. Great communication throughout the entire process.',
      rating: 5,
    },
    {
      name: 'James Robertson',
      role: 'Factory Operations Manager',
      content: 'Reliable and knowledgeable team. They handled our three-phase installation and ongoing maintenance with professionalism. It\'s refreshing to work with a company that delivers on their promises.',
      rating: 5,
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-navy mb-4">CLIENT FEEDBACK</h2>
          <div className="h-1 w-32 bg-gold mx-auto mb-6"></div>
          <p className="text-charcoal text-lg">
            Building our reputation one satisfied client at a time
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-xl p-12">
            <div className="flex justify-center mb-6">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-gold text-2xl w-6 h-6 flex items-center justify-center"></i>
              ))}
            </div>

            <p className="text-charcoal text-xl leading-relaxed mb-8 text-center italic">
              "{testimonials[currentIndex].content}"
            </p>

            <div className="text-center">
              <p className="font-bold text-navy text-lg">{testimonials[currentIndex].name}</p>
              <p className="text-gray-500">{testimonials[currentIndex].role}</p>
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-12 bg-navy text-gold w-12 h-12 rounded-full flex items-center justify-center hover:bg-gold hover:text-navy transition-all cursor-pointer shadow-lg"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-line text-2xl"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-12 bg-navy text-gold w-12 h-12 rounded-full flex items-center justify-center hover:bg-gold hover:text-navy transition-all cursor-pointer shadow-lg"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-gold w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
